module.exports = {
    "Male":         "Masculino",
    "Female":       "Feminino",
    "Other":        "Outro",
    "Uninformed":   "Prefiro não informar"
}